import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import {
  Section,
  SectionItem,
  SectionLink,
  SectionName,
} from '../components/Chrome';
import Icon from '../components/Icon';

const SettingsPage = () => (
  <>
    <Helmet>
      <title>Settings</title>
    </Helmet>
    <>
      {localStorage.getItem('token') ? (
        <>
          <Section>
            <SectionName>Settings</SectionName>
            <SectionLink to="main">
              Main
              <Icon name="arrow-right" />
            </SectionLink>
            <SectionLink to="data">
              Data
              <Icon name="arrow-right" />
            </SectionLink>
            <SectionLink to="spaces">
              Spaces
              <Icon name="arrow-right" />
            </SectionLink>
            <SectionLink to="sessions">
              Sessions
              <Icon name="arrow-right" />
            </SectionLink>
            <SectionLink to="appearance">
              Appearance
              <Icon name="arrow-right" />
            </SectionLink>
          </Section>
          <Outlet />
        </>
      ) : (
        <Section>
          <SectionItem>You must be logged in to view this page.</SectionItem>
        </Section>
      )}
    </>
  </>
);

export default SettingsPage;
